
export const GET_BOOKMARK_LIST :string = "/Bookmarks";
